/*
 * Copyright 2022. NXGN Management, LLC. All Rights Reserved.
 */

import { Component, Input } from "@angular/core";
import { FormGroup } from "@angular/forms";

@Component({
  selector: "app-pay-pal-detail-edit",
  templateUrl: "./pay-pal-detail-edit.component.html"
})
export class PayPalDetailEditComponent {
  @Input() payPalGroup!: FormGroup;
  @Input() editMode = false;

  get payPalGroupControls() {
    return this.payPalGroup.controls;
  }

  get cardNotPresentPasswordGroupControls() {
    const group = this.payPalGroupControls.cardNotPresentPasswordGroup as FormGroup;
    return group.controls;
  }

  get cardPresentPasswordGroupControls() {
    const group = this.payPalGroupControls.cardPresentPasswordGroup as FormGroup;
    return group.controls;
  }
}
